import React from "react";

function Data_Warehouse() {
  return (
    <div className="courseData">
      <div className="container">
        <div className="row">
          <div className="course_details_heading">
            <h1>Red Hat Certified Server Hardening RH 413</h1>
          </div>
          <div className="imgSection">
            <img
              src={require("../../../images/courses/Server Hardening.png")}
              alt=""
            />
          </div>
          <div className="heading">
            <h3>Red Hat Certified Server Hardening RH 413</h3>
            <p>
              Red Hat Certified Server Hardening RH 413 is one of the reputed
              certification in security certifications. Many security policies
              and standards require systems administrators to address specific
              user authentication concerns, application of updates, system
              auditing and logging, file system integrity, and more. Red Hat
              Certified Server Hardening RH 413 provides strategies for
              addressing specific policy and configuration concerns.Red Hat
              Certified Server Hardening RH 413 can also help you prepare for
              the Red Hat Certificate of Expertise in Server Hardening exam
              EX413.
            </p>

            <br />
            {/*  */}
            <h4>SKILLSET AFTER RED HAT CERTIFIED SERVER HARDENING RH 413 </h4>
            <ul>
              <li>
                Candidate will be eligible to Strengthen the security of servers
                . By using the Red Hat Enterprise Linux Server Hardening
                platform one can work on authentication layer using PAM.{" "}
              </li>
              <li>
                Professionals who complete this certification able to deploy and
                configure IPA Server (Identity Process Audit)for central
                authentication. .{" "}
              </li>
            </ul>
            {/*  */}
            <h4>ELIGIBILITY</h4>
            <ul>
              <li>
                {" "}
                Linux system administrators who are interested in or responsible
                for maintaining Security.
              </li>
              <li>
                Red Hat Certified System Administrator (RHCSA) certification or
                equivalent knowledge and experience{" "}
              </li>
            </ul>
            <br />
            <h3>Exam Code</h3>
            <p>Red Hat Certified Server Hardening (EX413).</p>
            {/*  */}
            <h3 style={{ color: "blue" }}>Red Hat Server Hardening (RH413)</h3>
            <br/>
            <h4>Track security updates</h4>
            <ul>
              <li>The Red Hat Security Response </li>
              <li>Red Hat Severity Scoring </li>
              <li>What ate CVEs and Red Hat Errata? </li>
              <li>Discuss Package Maintenance Through Back porting </li>
              <li>Engaging the Red Hat Security Response Team </li>
            </ul>
            {/*  */}

            <h4>Managing Software Updates</h4>
            <ul>
              <li>Develop an Update Process </li>
              <li>Applying Security Updates </li>
              <li>Validate Package Integrity and Scripts </li>
            </ul>
            {/*  */}
            <h4>Creating File Systems</h4>
            <ul>
              <li>Allocating File systems for Secure Containment </li>
              <li>Implementing Filesystem Encryption </li>
            </ul>
            {/*  */}
            <h4>Managing File Systems</h4>
            <ul>
              <li>Secure File systems Using Security-Related Mount Options </li>
              <li>Secure Individual Files with File system Attribute </li>
            </ul>
            {/*  */}
            <h4>Managing Special Permissions </h4>
            <ul>
              <li>Special Permissions Concepts </li>
              <li> Manipulating Special Permissions</li>
              <li>Auditing Files with Special Permissions </li>
            </ul>
            {/*  */}
            <h4>Managing Additional File Access Control</h4>
            <ul>
              <li>Setting Default File Permissions </li>
              <li>Managing Access Control Lists </li>
            </ul>
            {/*  */}
            <h4>Monitoring for File System Changes</h4>
            <ul>
              <li>Using Intrusion Detection Software to Monitor Changes </li>
            </ul>
            {/*  */}
            <h4>Managing User Accounts</h4>
            <ul>
              <li>Managing password Aging </li>
              <li>Auditing User Accounts </li>
            </ul>
            {/*  */}
            <h4>Managing Pluggable Authentication Module (PAM)</h4>
            <ul>
              <li>PAM Syntax and Configuration </li>
              <li>PAM Documentation </li>
              <li>Configure Password Requirements through PAM </li>
              <li>Supplementary PAM Configuration </li>
              <li>Lock Accounts with Multiple Failed Logins </li>
            </ul>
            {/*  */}
            <h4>Securing Console Access</h4>
            <ul>
              <li>Securing GRUB Boot loader</li>
              <li>Modifying Text Console Settings </li>
              <li>Modifying Graphical Console Settings </li>
            </ul>
            {/*  */}
            <h4>Installing Central Authentication</h4>
            <ul>
              <li>Installing an Identity Management (IDM) Server </li>
              <li>
                Adding User and Group Entries to identify Management (IDM){" "}
              </li>
              <li>
                Registering a client system with Identity Management (IDM){" "}
              </li>
            </ul>
            {/*  */}
            <h4>
            Managing Central Authentication
            </h4>
            <ul>
              <li>Controlling IDM User Access to Systems </li>
              <li>Managing Sudo on IdM client Systems </li>
            </ul>
            {/*  */}
            <h4>
            Configuring System Logging
            </h4>
            <ul>
              <li>Controlling IdM User Access to Systems </li>
              <li>Managing Log File Rotation </li>
            </ul>
            {/*  */}
            <h4>
            Configuring System Auditing
            </h4>
            <ul>
              <li>Configuring System Auditing </li>
              <li>Audit Reporting </li>
              <li>Writing Custom Audit Rules </li>
              <li>Using Predefined Audit Sets </li>
            </ul>
            {/*  */}
            <h4>
            Controlling Access to Network Service
            </h4>
            <ul>
              <li>Review of iptables Basics </li>
              <li>Advanced iptables </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Data_Warehouse;
